/**
 * Group one carrier column's deals by their consolidated-booking code.
 *
 * Deals sharing a `collection_reference_code` (`COL-…`) were booked as ONE
 * physical pickup and render as one card. Deals without a code (HubSpot-era,
 * or nothing booked yet) each form a group of one, which renders as the plain
 * card — so a board with no consolidations looks exactly as it always has.
 *
 * Order-preserving: a group sits where its first member sat. The caller hands
 * in a column already sorted by collection_date ascending, so a group's
 * position is its earliest date and the column stays date-sorted.
 *
 * @param {Array<object>} deals one column's deals, already date-sorted
 * @returns {Array<{code: string|null, deals: Array<object>}>}
 */
export function groupByCollection(deals) {
  const groups = []
  const byCode = new Map()
  for (const deal of deals) {
    const code = deal.collection_reference_code || null
    if (!code) {
      groups.push({ code: null, deals: [deal] })
      continue
    }
    const existing = byCode.get(code)
    if (existing) {
      existing.deals.push(deal)
    } else {
      const group = { code, deals: [deal] }
      byCode.set(code, group)
      groups.push(group)
    }
  }
  return groups
}
